import {
  FieldValues,
  useFormContext as useRHFormContext,
} from 'react-hook-form';

export function useFormContext<
  TFieldValues extends FieldValues = FieldValues,
>() {
  const formReturn = useRHFormContext<TFieldValues>();

  return {
    ...formReturn,
    visibleErrors: formReturn.formState.errors,
  };
}
